module.exports = __webpack_public_path__ + "media/images/client-17-14d5860d0b6d0883c27e2f4585d08bc8.png";